module.exports = __webpack_public_path__ + "assets/images/coin-50-print.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/coin-50-print.png
// module id = 143
// module chunks = 1